<template>
  <div class="app-container">
    <div class="head-container">
      <div class="filter-container">
        <el-input
          v-model="query.keyword"
          clearable
          size="small"
          placeholder="昵称/活动/门店/UID"
          class="filter-item"
          style="width: 220px; margin-right: 10px;"
          @keyup.enter.native="loadList"
        />
        <el-select
          v-model="query.storeCode"
          clearable
          filterable
          size="small"
          placeholder="门店编码"
          class="filter-item"
          style="width: 220px; margin-right: 10px;"
        >
          <el-option
            v-for="item in storeOptions"
            :key="item.storeCode"
            :label="(item.storeName || '') + ' [' + (item.storeCode || '') + ']'"
            :value="item.storeCode"
          />
        </el-select>
        <el-button class="filter-item" size="mini" type="primary" icon="el-icon-search" @click="loadList">
          查询
        </el-button>
        <el-button class="filter-item" size="mini" icon="el-icon-refresh-left" @click="resetQuery">
          重置
        </el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="list" size="small" style="width: 100%;">
      <el-table-column prop="uid" label="用户UID" width="100" />
      <el-table-column prop="nickName" label="昵称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="storeName" label="门店" min-width="120" show-overflow-tooltip />
      <el-table-column prop="storeCode" label="门店编码" min-width="120" show-overflow-tooltip />
      <el-table-column prop="activityName" label="活动名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="activityCode" label="活动编码" min-width="140" show-overflow-tooltip />
      <el-table-column prop="totalSealNum" label="打卡次数" width="90" align="center" />
      <el-table-column prop="status" label="状态" width="90" align="center">
        <template slot-scope="scope">
          {{ statusLabel(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="lastSealTime" label="最后打卡" width="170">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.lastSealTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="参与时间" width="170">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.createTime) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 16px; text-align: right;"
      background
      layout="total, prev, pager, next, sizes"
      :current-page="query.page + 1"
      :page-size="query.size"
      :page-sizes="[10, 20, 50]"
      :total="total"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { fetchSignsStores, fetchSignsUsers } from '@/api/h5-admin-signs'

export default {
  name: 'H5AdminSignsUsers',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      storeOptions: [],
      query: {
        page: 0,
        size: 20,
        keyword: '',
        storeCode: null
      }
    }
  },
  created() {
    this.loadStores()
    this.loadList()
  },
  methods: {
    formatDateTime(value) {
      if (value == null || value === '') return '-'
      const d = dayjs(value)
      return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : String(value)
    },
    statusLabel(status) {
      if (status === 0) return '进行中'
      if (status === 1) return '已结束'
      if (status === 2) return '已禁止'
      if (status === 3) return '已核销'
      return status == null ? '-' : String(status)
    },
    loadStores() {
      fetchSignsStores()
        .then(res => {
          this.storeOptions = res.data || []
        })
        .catch(() => {
          this.storeOptions = []
        })
    },
    loadList() {
      this.loading = true
      const params = {
        page: this.query.page,
        size: this.query.size,
        keyword: this.query.keyword || undefined,
        storeCode: this.query.storeCode || undefined
      }
      fetchSignsUsers(params)
        .then(res => {
          const data = res.data || {}
          this.list = data.content || []
          this.total = data.totalElements || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetQuery() {
      this.query.keyword = ''
      this.query.storeCode = null
      this.query.page = 0
      this.loadList()
    },
    handlePageChange(page) {
      this.query.page = Math.max(page - 1, 0)
      this.loadList()
    },
    handleSizeChange(size) {
      this.query.size = size
      this.query.page = 0
      this.loadList()
    }
  }
}
</script>
